<template>
    <div class="modal-card card">
        <form @submit.prevent="onAddCertificate()">
            <div class="card-header">
                <!-- Title -->
                <h4 class="card-header-title">
                    Create Certificate
                </h4>
                <!-- Close -->
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="card-body">
                <!-- <div>
                    <input-field :inlineField="true" label="Name" type="text" v-model="certificate.commonName" />
                    <input-field :inlineField="true" label="Sans" type="multiselect" v-model="certificate.sans" />
                    <input-field :inlineField="true" label="FIPS Enabled" type="radio" v-model="certificate.fipsEnabled"
                        :options="options" />
                    <br>
                    <h3>Admin Details</h3>
                    <input-field :inlineField="true" label="Email" type="text" :placeholder="'aut@aqfer.com'"
                        v-model="admin.emain" />
                    <input-field :inlineField="true" label="First Name" type="text" v-model="admin.firstName" />
                    <input-field :inlineField="true" label="Last Name" type="text" v-model="admin.lastName" />
                    <input-field :inlineField="true" label="Phone" type="text" v-model="admin.phone" />
                    <br>
                    <h3>Organization Details</h3>
                    <input-field :inlineField="true" label="Name" type="text" v-model="organization.organizationName" />
                    <input-field :inlineField="true" label="Unit" type="text" v-model="organization.organizationUnit" />
                    <input-field :inlineField="true" label="Country" type="text" v-model="organization.country" />
                    <input-field :inlineField="true" label="State" type="text" v-model="organization.state" />
                    <input-field :inlineField="true" label="Locality" type="text" v-model="organization.locality" />
                    <input-field :inlineField="true" label="Address Line 1" type="text" v-model="organization.addressLineOne" />
                    <input-field :inlineField="true" label="Address Line 2" type="text" v-model="organization.addressLineTwo" />
                    <input-field :inlineField="true" label="Phone" type="text" v-model="organization.phone" />
                    <input-field :inlineField="true" label="Postal Code" type="text" v-model="organization.postalCode" />
                </div> -->
                <div>
                    <input-field :inlineField="false" label="Name" type="text" v-model="certificate.commonName"
                        :validate="getValidation('Name')" />
                    <input-field :inlineField="false" label="Sans" type="multiselect" v-model="certificate.sans"
                        :validate="getValidation('Sans')" />
                    <br>
                    <h3>Admin Details</h3>
                    <div class="d-flex gap-3" style="overflow-x: hidden; flex-wrap: wrap;">
                        <div style="flex: 1;">
                            <input-field :inlineField="false" label="Email" type="text" v-model="admin.email"
                                :placeholder="'aut@aqfer.com'" :validate="getValidation('Email')" />
                        </div>
                        <div style="flex: 1;">
                            <input-field :inlineField="false" label="Phone" type="text" v-model="admin.phone"
                                :validate="getValidation('Phone')" />
                        </div>
                    </div>
                    <div class="d-flex gap-3" style="overflow-x: hidden; flex-wrap: wrap;">
                        <div style="flex: 1;">
                            <input-field :inlineField="false" label="First Name" type="text" v-model="admin.firstName"
                                :validate="getValidation('First Name')" />
                        </div>
                        <div style="flex: 1;">
                            <input-field :inlineField="false" label="Last Name" type="text" v-model="admin.lastName"
                                :validate="getValidation('Last Name')" />
                        </div>
                    </div>

                    <br>
                    <h3>Organization Details</h3>
                    <div class="d-flex gap-3" style="overflow-x: hidden; flex-wrap: wrap;">
                        <div style="flex: 1;">
                            <input-field :inlineField="false" label="Name" type="text"
                                v-model="organization.organizationName"
                                :validate="getValidation(`Organization's Name`)" />
                        </div>
                        <div style="flex: 1;">
                            <input-field :inlineField="false" label="Unit" type="text"
                                v-model="organization.organizationUnit" />
                        </div>
                    </div>
                    <input-field :inlineField="false" label="Country" type="text" v-model="organization.country"
                        :validate="getValidation('Country')" />
                    <div class="d-flex gap-3" style="overflow-x: hidden; flex-wrap: wrap;">
                        <div style="flex: 1;">
                            <input-field :inlineField="false" label="State" type="text" v-model="organization.state"
                                :validate="getValidation('State')" />
                        </div>
                        <div style="flex: 1;">
                            <input-field :inlineField="false" label="Locality" type="text"
                                v-model="organization.locality" :validate="getValidation('Locality')" />
                        </div>
                    </div>
                    <input-field :inlineField="false" label="Address Line 1" type="text"
                        v-model="organization.addressLineOne" :validate="getValidation('Address Line 1')" />
                    <input-field :inlineField="false" label="Address Line 2" type="text"
                        v-model="organization.addressLineTwo" />
                    <div class="d-flex gap-3" style="overflow-x: hidden; flex-wrap: wrap;">
                        <div style="flex: 1;">
                            <input-field :inlineField="false" label="Phone" type="text" v-model="organization.phone"
                                :validate="getValidation(`Organization's Phone`)" />
                        </div>
                        <div style="flex: 1;">
                            <input-field :inlineField="false" label="Postal Code" type="text"
                                v-model="organization.postalCode" :validate="getValidation('Postal Code')" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <div class="text-end">
                    <button type="submit" class="btn btn-primary" :disabled="creating">
                        <div v-if="creating" class="spinner-border spinner-border-sm" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        <div v-else>
                            Submit
                        </div>
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import { mapActions } from "vuex/dist/vuex.cjs.js";
import InputField from "../../components/InputField.vue";
export default {
    components: { InputField },
    name: "AddCertificate",
    data() {
        return {
            creating: false,
            certificate: {},
            admin: {},
            organization: {},
            options: [
                { label: "TRUE", value: "true" },
                { label: "FALSE", value: "false" }
            ]
        }
    },
    methods: {
        ...mapActions({
            createCertificate: "aut/createCertificate",
        }),
        getValidation(name) {
            return [
                { type: 'required', errMsg: `${name} is required` }
            ]
        },
        async onAddCertificate() {
            this.creating = true;
            let isCertCreated = false;
            let toastOptions;
            this.certificate.admin = this.admin;
            this.certificate.org = this.organization;
            await this.createCertificate(this.certificate).then((response) => {
                toastOptions = {
                    message: "Certificate created successfully.",
                    type: "success"
                }
                this.$store.dispatch('hideModal')
                isCertCreated = true;
            }).catch(err => {
                console.log("error: ", err)
                let error = null
                if (err.response)
                    error = err.response.data.error;
                else error = err.message;
                toastOptions = {
                    message: error || "Something went wrong while creating certificate. Please contact support.",
                    type: "error"
                }
            })
            this.creating = false;
            this.$store.dispatch("addToast", toastOptions);
            if (isCertCreated) {
                this.$store.state.aut.listCertTrigger = !this.$store.state.aut.listCertTrigger // trigger to get the new list of certificates
            }
        }
    }
};
</script>

<style></style>